import { connect } from 'react-redux';

import { isEventTicketItemData } from 'common/helpers/featureFlags';
import { addCartItem } from 'redux/cart/actions';

// eslint-disable-next-line import/no-cycle
import LoginToPurchase from './LoginToPurchase';
import AddToCartEvent from './addToCart/AddToCartEvent';
import AddToCartGiftCard from './addToCart/AddToCartGiftCard';
import AddToCartRegular from './addToCart/AddToCartRegular';

const AddToCart = (props) => {
  const { product, hidePrice, settings, showVariantTitle } = props;
  if (product.webStatus !== 'Available') {
    return null;
  }
  if (!product.variants || product.variants.length === 0) {
    return null;
  }
  if (
    product.security &&
    product.security.availableTo !== 'Public' &&
    !product.security.isValidUser
  ) {
    return <LoginToPurchase product={product} />;
  }
  const firstSku = product.variants[0] && product.variants[0].sku;
  if (product.type === 'Gift Card' && product.giftCard.type === 'Virtual') {
    return (
      <AddToCartGiftCard
        product={product}
        hidePrice={hidePrice}
        settings={settings}
        showVariantTitle={showVariantTitle}
      />
    );
  }
  if (isEventTicketItemData(product.type, firstSku)) {
    return (
      <AddToCartEvent
        product={product}
        hidePrice={hidePrice}
        settings={settings}
        showVariantTitle={showVariantTitle}
      />
    );
  }
  return (
    <AddToCartRegular
      product={product}
      hidePrice={hidePrice}
      settings={settings}
      showVariantTitle={showVariantTitle}
    />
  );
};

export default connect(null, { addCartItem })(AddToCart);
